import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { Providers } from "./app/providers";
import "./app/install"; // listens for the install offer from first load
import { startPwa } from "./app/pwa";
import { router } from "./app/router";
import { installErrorReporting } from "./lib/report-error";
import "./ui/ui.css";
import "./app/app.css";

installErrorReporting();
startPwa();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
